import styled from 'styled-components'

import CdnImage from '@/components/cdn-image'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

const PhotoWrapper = styled.div`
  position: relative;
  height: 100%;
  overflow: hidden;
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    backdrop-filter: blur(3px);
    -webkit-backdrop-filter: blur(3px);
    z-index: 1;
    border-radius: 10px;
  }
`

const PhotoSliderBlurred = ({
  images,
  sizes = '100vw'
}: {
  images: string[]
  sizes?: string
}) => {
  const image = images[0]
  return (
    <PhotoWrapper>
      <CdnImage
        src={image}
        placeholder={'blur'}
        layout="fill"
        sizes={sizes}
        objectFit="cover"
        alt={'blurred-listing-image'}
      />
    </PhotoWrapper>
  )
}

export default PhotoSliderBlurred
